<!-- 关注 -->
<template>
  <div class="button">
    <div v-if="!item.isFocus" @click.stop="clickAttention(item, true)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/guanzhu.png" alt />
      <span>关注</span>
    </div>
    <div v-else @click.stop="clickAttention(item, false)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/yiguanzhu.png" alt />
      <span>已关注</span>
    </div>
  </div>
</template>

<script>
import {apiResignAll} from "@/api/apiResignAll"
import apiHelp from "@/api/apiHelp"
import {checkDataStatusMessage} from "@/utils/checkDataStatus"

export default {
  name: "focus",
  inject:['cardListCom'],
  props:{
    item:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  data(){
    return {
      loading:false
    }
  },
  methods:{
    async clickAttention(item, state){
      if(this.permissionTips()) return

      let no = this.item.no
      if(this.$parent.type==2){
        no = this.item.companyNo
      }
      const dataState = await checkDataStatusMessage.call(this,this.$parent.type,no)
      if(!dataState || dataState!=1){
        return
      }

      if (this.loading) return

        this.loading = true;
        //添加身份状态判断type 0 普通用户 1 企业用户
        let str=state?'关注成功':'取消关注成功';
        if(this.$store.state.user.type!=0&&state){
          str='关注成功，请切换到个人身份-智能关注中查看'
        }
        if(this.$parent.type==2){
          apiHelp
            .attentionHandle({businessNo: item.companyNo,type: 0})
            .then(v=>{
              if(v.data.code==200){
                this.$toast(str, 'success')
                item.isFocus=state;
              }else{
                this.$toast(res.data.msg, 'error')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }else{
          apiResignAll
            .addAttention(item.no, this.$parent.type, state)
            .then(res => {
              if (res.data.code === 200 && res.data.data !== "不能关注自己发布的信息") {
                item.isFocus = !item.isFocus
                if(res.data.data=='关注成功'){
                  res.data.data=str
                }
                this.$toast(res.data.data, res.data.data.indexOf('关注成功')>-1?'success':'cancel')
              } else {
                if(res.data.data) this.$toast(res.data.data, 'error')
                else if(res.data.msg)this.$toast(res.data.msg, 'error')
              }
            })
            .finally(() => {
              this.loading = false
            })

      }
    },
  }
}
</script>

<style scoped>
</style>
